// main.tsx
//import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import './index.css'

import { store, persistor } from './store/store';
import { ThemeProvider } from '@/components/theme-provider';


ReactDOM.createRoot(document.getElementById('root')!).render(
  //<StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <DndProvider backend={HTML5Backend}>
          <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
            <App />
            </ThemeProvider>
          </DndProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  //</StrictMode>
);
